
import { ElRowClassNameParams } from "@/types/element.type";
import { defineComponent } from "vue";
import { debounce } from "lodash";
import PageHeaderComponent from "../PageHeader.component.vue";
import { Station } from "@/types/station.type";
import { Filter } from "@/types/filter.type";
import { getStations, changeActiveStation } from "@/service/station.service";
import { Action, ElMessage, ElMessageBox } from "element-plus";
import StationFormComponentVue from "./StationForm.component.vue";
import StationFormComponent from "./StationForm.component.vue";
import StationConfigFormComponent from "./StationConfigForm.component.vue";

export default defineComponent({
  components: { PageHeaderComponent, StationFormComponent, StationConfigFormComponent },
  props: {
    canWrite: {
      type: Boolean,
      default: false,
    },
    containerId: {
      type: Number,
    },
  },
  data() {
    return {
      entities: [] as Station[],
      currentPage: 0 as number,
      rowPerPage: 10 as number,
      totalRows: 0 as number,
      query: "" as string,
      showEntityForm: false,
      showConfigEntityForm: false,
      entitySelected: undefined as undefined | Station,
    };
  },
  created() {
    // - apply delay
    this.search = debounce(this.refreshEntities, 300);
  },
  mounted() {
    this.currentPage = 1;
    this.refreshEntities();
  },
  methods: {
    search(): void {
      this.refreshEntities();
    },
    /**
     * table row css class name
     * @param params
     * @return css class name
     */
    tableRowClassName(params: ElRowClassNameParams<Station>): string {
      return params.row && params.row.active ? "" : "disable-row";
    },

    /**
     * set page
     * @param page
     */
    changePaginationSize(size: number): void {
      this.rowPerPage = size;
      this.refreshEntities();
    },

    /**
     * change page
     * @param {number} page
     */
    changePaginationPage(page: number): void {
      this.currentPage = page;
      this.refreshEntities();
    },

    /**
     * confirm activate item
     * @param item
     */
    confirmActivateItem(item: Station) {
      ElMessageBox.confirm(
        this.$t("confirm.activateStation", { name: item.name }),
        this.$t("label.warning"),
        {
          confirmButtonText: this.$t("btn.accept"),
          cancelButtonText: this.$t("btn.cancel"),
          type: "warning",
          dangerouslyUseHTMLString: true,
          callback: (action: Action) => {
            if (action === "confirm") {
              this.changeStatusEntity(item, true);
            }
          },
        }
      );
    },

    /**
     * confirm deactivate action
     * @param item
     */
    confirmDeactivateItem(item: Station) {
      ElMessageBox.confirm(
        this.$t("confirm.deactivateStation", { name: item.name }),
        this.$t("label.warning"),
        {
          confirmButtonText: this.$t("btn.accept"),
          cancelButtonText: this.$t("btn.cancel"),
          type: "warning",
          dangerouslyUseHTMLString: true,
          callback: (action: Action) => {
            if (action === "confirm") {
              this.changeStatusEntity(item, false);
            }
          },
        }
      );
    },

    /**
     * change status station
     * @param item
     * @param active
     */
    async changeStatusEntity(item: Station, active: boolean) {
      if (!item.id) return;
      // TODO este metodo deberia indicar que estado debe aplicar
      await changeActiveStation(item.id);
      ElMessage.success(this.$t("success.action"));

      // - refrehs item
      this.refreshEntities();
    },

    /**
     * refresh stations item from list items
     * @param item
     */
    async refreshEntities(item: Station | undefined = undefined) {
      let index = -1;
      if (this.entities && item) {
        index = this.entities.findIndex((i) => i.id === item.id);
      }
      if (index !== -1 && item) {
        this.entities[index] = item;
      } else {
        const filter: Filter = {};
        if (this.query) {
          filter.multi = this.query;
        }
        if (this.containerId) {
          filter.fields = { "station.containerId": { operator: "equal", value: this.containerId } };
        }

        const pagination = await getStations(this.currentPage, this.rowPerPage, filter);
        this.totalRows = pagination.totalRows;
        this.entities = pagination.data;
      }
    },

    /**
     * open form Dialog
     * @param item
     */
    openEntityFormDialog(item: Station | undefined = undefined) {
      this.entitySelected = item;
      this.showEntityForm = true;
    },

    /**
     * open form config ialog
     * @param item
     */
    openEntityFormConfigDialog(item: Station | undefined = undefined) {
      this.entitySelected = item;
      this.showConfigEntityForm = true;
    },

    /**
     * close station formDialog
     */
    closeEntityDialog() {
      this.showEntityForm = false;
      this.showConfigEntityForm = false;
      this.entitySelected = undefined;
    },

    /**
     * save station
     */
    async saveEntity() {
      // - call stationForm save method
      await (this.$refs["stationForm"] as InstanceType<typeof StationFormComponentVue>).doSave();

      // - close dialog and refresh
      this.closeEntityDialog();
      this.refreshEntities();
      ElMessage.success(this.$t("success.action"));
    },

    /**
     * save configuration
     */
    async saveConfiguration() {
      // - call stationConfigForm save method
      await (
        this.$refs["stationConfigForm"] as InstanceType<typeof StationConfigFormComponent>
      ).doSave();

      // - close dialog and refresh
      this.closeEntityDialog();
      this.refreshEntities();
      ElMessage.success(this.$t("success.action"));
    },
  },
});
